import theme from '../../../themes/pTheme/pTheme'

// legendplugin
const getOrCreateLegendList = (chart, id) => {
  const legendContainer = document.getElementById(id)
  let listContainer = legendContainer?.querySelector('ul')

  if (!listContainer) {
    listContainer = document.createElement('ul')
    listContainer.style.display = 'flex'
    listContainer.style.flexDirection = 'row'
    listContainer.style.margin = 0
    listContainer.style.padding = 0

    legendContainer?.appendChild(listContainer)
  }

  return listContainer
}

export const htmlLegendPlugin = {
  id: 'htmlLegend',
  afterUpdate(chart, args, options) {
    const ul = getOrCreateLegendList(chart, options.containerID)

    // Remove old legend items
    while (ul.firstChild) {
      ul.firstChild.remove()
    }
    ul.style.flexWrap = 'wrap'
    // Reuse the built-in legendItems generator
    const items = chart.options.plugins.legend.labels.generateLabels(chart)
    for (const item of items) {
      const li = document.createElement('li')
      li.style.alignItems = 'center'

      li.style.display = 'flex'
      li.style.flexDirection = 'row'
      li.style.marginLeft = '10px'

      // Color box
      const boxSpan = document.createElement('span')
      boxSpan.style.background = item.fillStyle
      boxSpan.style.borderRadius = '50%'
      boxSpan.style.borderColor = item.strokeStyle
      boxSpan.style.borderWidth = item.lineWidth + 'px'
      boxSpan.style.display = 'inline-block'
      boxSpan.style.flexShrink = 0

      boxSpan.style.height = '14px'
      boxSpan.style.marginRight = '10px'
      boxSpan.style.width = '14px'

      // Text
      const textContainer = document.createElement('p')

      textContainer.style.color = theme.palette.hpAccentBlack
      textContainer.style.margin = 0
      textContainer.style.padding = 0

      textContainer.style.fontSize = theme.typography.subtitle1.fontSize
      textContainer.style.fontWeight = theme.typography.fontWeightRegular

      textContainer.style.textDecoration = item.hidden ? 'line-through' : ''

      const text = document.createTextNode(item.text)
      textContainer.appendChild(text)

      li.appendChild(boxSpan)
      li.appendChild(textContainer)
      ul.appendChild(li)
    }
  }
}
